import { Navigate, Outlet } from "react-router";
import { AUTH_ROUTES } from "@/src/auth/constants/auth-routes";
import { getIsAuthenticated } from "@/src/auth/store/auth-selectors";
import { useAppSelector } from "@/src/common/redux/store";

export function VideoRouteLayout() {
	const isAuthenticated = useAppSelector(getIsAuthenticated);

	if (!isAuthenticated) {
		return <Navigate to={AUTH_ROUTES.AUTH} replace />;
	}

	return <Outlet />;
}
